export var Curriculum;
(function (Curriculum) {
    Curriculum["FR"] = "FR";
    Curriculum["EN"] = "EN";
})(Curriculum || (Curriculum = {}));
/**
 * @deprecated will be replaced by Curriculum
 */
export var Language;
(function (Language) {
    Language["FR"] = "FR";
    Language["EN"] = "EN";
})(Language || (Language = {}));
export const assetFolder = {
    [Curriculum.FR]: 'fr',
    [Curriculum.EN]: 'en',
};
//# sourceMappingURL=curriculum.js.map